import React from 'react';
import { useSelector } from 'react-redux';

import { FF_HOLIDAY_BANNER_CN, FF_HOLIDAY_BANNER_VN } from 'constants/features';
import { usePeertransferFlags } from 'hooks/usePeertransferFlags/usePeertransferFlags';
import { isPayingFromChina, isPayingFromVietnam } from 'selectors';

import './HolidayBanner.scss';

function Vietnam() {
  return (
    <div className="HolidayBanner">
      <div className="HolidayBanner-content">
        <div className="HolidayBanner-title">Quan trọng:</div>
        <p className="HolidayBanner-description">
          Xin lưu ý rằng khoảng thời gian từ ngày{' '}
          <b>29 tháng 4 đến hết ngày 1 tháng 5 năm 2024</b> là thời gian nghỉ lễ
          tại Việt Nam. Do đó, các khoản thanh toán chuyển khoản ngân hàng nhận
          được trong thời gian nghỉ lễ này sẽ chỉ được xử lý và trạng thái thanh
          toán sẽ chỉ được cập nhật vào hoặc sau ngày <b>2 tháng 5 năm 2024</b>.
          <br />
          Chúng tôi khuyên bạn nên lập kế hoạch thanh toán trước để tránh bất kỳ
          sự chậm trễ nào trong việc thanh toán của bạn. Chúng tôi xin lỗi nếu
          có bất kỳ sự bất tiện nào gây ra trong khoảng thời gian này và cảm ơn
          sự kiên nhẫn của bạn. Vui lòng truy cập{' '}
          <a
            target="_blank"
            href="https://help.flywire.com/hc/vi"
            rel="noreferrer"
          >
            Trung tâm trợ giúp & hỗ trợ
          </a>{' '}
          của chúng tôi và liên hệ với nhóm hỗ trợ nếu bạn có bất kỳ câu hỏi
          nào!
          <br />
          Chúng tôi chúc bạn một kỳ nghỉ tốt đẹp!
        </p>
      </div>
    </div>
  );
}

function China() {
  return (
    <div className="HolidayBanner">
      <div className="HolidayBanner-content">
        <div className="HolidayBanner-title">重要提醒:</div>
        <p className="HolidayBanner-description">
          因国庆节假期（10月1日至7日），请注意，9月30日及之后的所有支付款项，将统一在10月8日或之后的工作日处理并更新状态。
          <br />
          请您提前规划付款事宜，以避免不必要的延误。如有任何疑问或需要帮助，请随时访问“
          <a
            target="_blank"
            href="https://help.flywire.com/hc/zh-cn"
            rel="noreferrer"
          >
            帮助页面
          </a>
          ”联系我们。
          <br />
          飞汇在此提前祝您国庆佳节愉快！
        </p>
      </div>
    </div>
  );
}

China.displayName = 'HolidayBanner.China';
Vietnam.displayName = 'HolidayBanner.Vietnam';

const REFETCH_TIMEOUT = 60000;

function HolidayBanner() {
  const fromChina = useSelector(isPayingFromChina);
  const fromVietnam = useSelector(isPayingFromVietnam);

  const shouldDisplayHolidayBanner = fromChina || fromVietnam;

  const { data: flags } = usePeertransferFlags(
    [FF_HOLIDAY_BANNER_CN, FF_HOLIDAY_BANNER_VN],
    {
      refetchInterval: REFETCH_TIMEOUT,
      enabled: shouldDisplayHolidayBanner,
    },
  );

  if (!flags) {
    return null;
  }

  const showChineseBanner = fromChina && flags[FF_HOLIDAY_BANNER_CN];
  const showVietnameseBanner = fromVietnam && flags[FF_HOLIDAY_BANNER_VN];

  return (
    <>
      {showChineseBanner && <China />}
      {showVietnameseBanner && <Vietnam />}
    </>
  );
}

export { HolidayBanner };
